import {axios, HOST, config} from './settiing';

export default {
  getDriversMembershipCards(driverId) {
    return axios.get(`${HOST}/resource/membership/driver/${driverId}`, config);
  },
}